import { useQuery, UseQueryOptions } from 'react-query';

import { BorrowerParticipant, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomBorrowerParticipantsQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<BorrowerParticipant, unknown, BorrowerParticipant>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomContacts.BorrowerParticipants(guid),
		() =>
			AxiosUtils.getResponseData<BorrowerParticipant>(
				api.get(CerebroApiEndpoints.CompanyContacts.BorrowerParticipants(guid))
			),
		options
	);
}
